@if(f){
<div class="login-main">
    <!-- Add loader component here -->
    <app-loader [loading]="isLoading"></app-loader>
    <form class="theme-form needs-validation" [formGroup]="form" ngNativeValidate>
        <h4>Sign In to Super Admin Account</h4>
        <p>Enter your email & password to login</p>
        <div class="form-group">
            <label class="col-form-label">Email Address</label>
            <input class="form-control" formControlName="email" type="email" required="" placeholder="Email"
                maxlength="50" />
            <div class="form-error">
                @if (validate && formValidation.isInvalidField(form,'email')) {
                <div>{{formValidation.getErrorMessage(form,'email')}}</div>
                }
            </div>
        </div>
        <div class="form-group">
            <label class="col-form-label">Password</label>
            <div class="form-input position-relative">
                <input class="form-control" formControlName="password" type="password" name="password" required=""
                    maxlength="50" [type]="show ? 'password' : 'text'" placeholder="*********" />
                <div class="show-hide">
                    <span (click)="show = !show" [class.show]="show"></span>
                </div>
            </div>
            @if (validate && formValidation.isInvalidField(form,'password')) {
            <div class="form-error">
                <div>{{formValidation.getErrorMessage(form,'password')}}</div>
            </div>
            }
        </div>
        <div class="form-group mb-0">
            <div class="checkbox p-0">
                <a href="/forgot-password" (click)="openForgotPassword(); $event.preventDefault();" class="pointer pa">
                    Forgot Password?
                </a>
            </div>

            <div class="text-end mt-3">
                <button class="btn btn-primary btn-block w-100" (click)="signIn()" type="submit">
                    Sign In
                </button>
            </div>
        </div>
    </form>
</div>
}